import React from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Close } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";
import ToastBody from "@/components/ui/toast-body";

interface Props {
  successTitle: string;
  undoLabel: string;
  handleUndo: () => void;
  refreshTasks: () => void;
}

const SuccessToast: React.FC<Props> = ({
  successTitle,
  undoLabel,
  handleUndo,
  refreshTasks
}) => {
  const { t } = useTranslation();

  return (
    <ToastBody
      title={successTitle}
      actions={
        <>
          <Button
            variant="secondaryNoBg"
            onClick={() => {
              handleUndo();
              refreshTasks();
              toast.dismiss();
            }}
          >
            {undoLabel}
          </Button>
          <IconButton
            aria-label={t("close")}
            onClick={() => toast.dismiss()}
            size="md"
            variant="iconNoBg"
            iconColor="secondary"
          >
            <Close />
          </IconButton>
        </>
      }
    />
  );
};

export default SuccessToast;
